import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {ExtensionsTable} from "./components/ExtensionsTable";
import {getExtensions} from "../../store/reducers/ExtensionsSlice";
import {ExtensionsFilter} from "./components/ExtensionsFilter";

interface ExtensionsScreenProps {
}

export const ExtensionsScreen: React.FC<ExtensionsScreenProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getExtensions());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Pikendused</h1>
            <ExtensionsFilter />
            <ExtensionsTable />
        </LoggedInView>
    )

}